<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-title>会員登録</v-card-title>
      <v-card-subtitle>
        会員登録をしてください。配送先ご住所やお支払い方法のご登録、ご変更に必要です。
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="signUpWithGoogle" class="btn-sign-in">
              <img src="/ic_google@3x.png" />
              Googleでサインアップ
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="signUpWithEmail" class="btn-sign-in">
              <img src="/ic_email@3x.png" />
              Emailでサインアップ
            </v-btn>
          </v-col>
        </v-row>
        <sign-in-message></sign-in-message>
        <terms-message></terms-message>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'
import { getQueryParamsStringFromJson, saveUserAndRedirect } from './SignIn.vue'
import { firebase, firebaseAuth } from '@/services/firebase'
import { alertError } from '@/helpers/error'
import SignInMessage from '@/components/messages/SignInMessage.vue'
import TermsMessage from '@/components/messages/TermsMessage.vue'

const userStore = createNamespacedHelpers('user')

export default {
  components: { SeaPlusNavIcon, AccumulateNavButton, SignInMessage, TermsMessage },
  computed: {
    plan() {
      return this.$route.query.plan
    }
  },
  methods: {
    ...userStore.mapActions(['updateUser']),
    signUpWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider()
      provider.addScope('email')
      firebaseAuth.signInWithPopup(provider).then(
        (userCredential) => {
          console.log({ userCredential })
          saveUserAndRedirect({
            $this: this,
            userCredential
          })
        },
        (error) => {
          alertError(error)
        }
      )
    },
    signUpWithEmail() {
      this.$router.replace(`/sign-up-with-email${getQueryParamsStringFromJson({ plan: this.plan })}`)
    }
  }
}
</script>

<style>
.my-v-card .v-btn.btn-sign-in img {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0px;
}
.my-v-card .v-btn.btn-sign-in .v-btn__content {
  text-transform: none;
  color: white;
  font-weight: normal;
  font-size: 1.2em;
}
</style>
